import React from "react";

import { ModalCloseCross } from "@/components/modal/components/ModalCloseCross";
import { CommonModalProps } from "@/components/modal/models";
import { Paper } from "@/components/paper/Paper";
import { ForgotPasswordForm } from "@/features/forms/forgot-password-form/ForgotPasswordForm";

export const ForgotPasswordFormModal: React.FC<CommonModalProps> = ({
  onClose,
}) => {
  return (
    <Paper
      data-testid="forgotPasswordModal"
      className="p-4 py-8 md:p-8 max-w-[400px] min-h-min relative"
    >
      <ModalCloseCross absolute onClose={onClose} />
      <ForgotPasswordForm />
    </Paper>
  );
};
